// CLASSES

export default function (props, state) {

	/**
	 * Check size of all uploaded documents to make sure it does not exceed 8 MB
	 */
	let totalDocumentsSize = 0;
	state.docs.forEach(function(doc) {
		totalDocumentsSize += (doc.size / 1024); // Size is in bytes, convert to kb
	});

	return totalDocumentsSize <= 8192;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/AttachFiles/AttachFiles.fulfillment.js